import TicketPlanListContainer from '../../../../Componant/Application/Ecommerce/ProductList/TicketPlanList'

const TicketPlanList = () => {
  return (
    <div className='page-body'>
      <TicketPlanListContainer />
    </div>
  )
}

export default TicketPlanList